import { visitorLocationService } from "../backendServices/visitorLocationService";

const getCurrentPosition = () =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      timeout: 10000, // 10 seconds timeout
    });
  });

const saveVisitorLocationService = async (locationData) => {
  try {
    const response = await visitorLocationService(locationData);
    return response;
  } catch (error) {
    console.error("Error in saveVisitorLocationService:", error);
    throw error;
  }
};

const getLocation = async () => {
  if (!navigator.geolocation) {
    console.log("Geolocation is not supported by this browser.");
    return;
  }

  try {
    const position = await getCurrentPosition();
    const { latitude: lat, longitude: long } = position.coords;

    if (lat && long) {
      console.log("Loc: ", lat, long);
      const response = await saveVisitorLocationService({ lat, long });
      console.log("Location saved:", response?.data?.message || "Success");
    }
  } catch (error) {
    switch (error.code) {
      case 1:
        console.log(
          "Geolocation access denied. Please allow location access or use HTTPS."
        );
        break;
      case 2:
        console.log("Location unavailable. Check your connection or GPS.");
        break;
      case 3:
        console.log("Geolocation timed out. Please try again.");
        break;
      default:
        console.log("An unknown error occurred:", error);
    }
  }
};

export default getLocation;
